import app from 'flarum/forum/app';

/**
 * Triggered when the push token is generated by the device.
 */
export const PushToken = 'push-token';

/**
 * Triggered when the user requests permission on the push event.
 */
export const PushPermissionRequest = 'push-permission-request';

/**
 * Returns the state of the push request of the device.
 */
export const PushPermissionState = 'push-permission-state';
/**
 * Check if the client is a webview in an iOS or iPadOS device.
 */
export const usingAppleWebview = () => !!(window.webkit && window.webkit.messageHandlers);
export const requestPushPermissionState = () => {
  if (usingAppleWebview()) {
    window.webkit.messageHandlers[PushPermissionState].postMessage(PushPermissionState);
  }
};
export const requestPushPermissions = () => {
  if (usingAppleWebview()) {
    window.webkit.messageHandlers[PushPermissionRequest].postMessage(PushPermissionRequest);
  }
};
export const requestPushToken = () => {
  if (usingAppleWebview()) {
    window.webkit.messageHandlers[PushToken].postMessage(PushToken);
  }
};
export const usePWABuilder = () => {
  let permissionState = 'granted';
  const handlePushPermissionRequest = event => {
    const customEvent = event;
    if (customEvent.detail !== 'granted') {
      return;
    }
    permissionState = 'granted';
    requestPushToken();
  };
  const handlePushToken = event => {
    const customEvent = event;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/pwa/firebase-push-subscriptions',
      body: {
        token: customEvent.detail
      }
    });
  };
  const handlePushPermissionState = event => {
    const customEvent = event;
    permissionState = customEvent.detail;
    m.redraw();
  };
  const hasFirebasePushState = state => state === permissionState;
  function registerFirebasePushNotificationListeners() {
    if (!usingAppleWebview()) {
      return;
    }
    requestPushPermissionState();
    window.addEventListener(PushPermissionRequest, handlePushPermissionRequest);
    window.addEventListener(PushPermissionState, handlePushPermissionState);
    window.addEventListener(PushToken, handlePushToken);
  }
  function removeFirebasePushNotificationListeners() {
    if (!usingAppleWebview()) {
      return;
    }
    window.removeEventListener(PushPermissionRequest, handlePushPermissionRequest);
    window.removeEventListener(PushPermissionState, handlePushPermissionState);
    window.removeEventListener(PushToken, handlePushToken);
  }
  return {
    hasFirebasePushState,
    registerFirebasePushNotificationListeners,
    removeFirebasePushNotificationListeners
  };
};